import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useUISettings } from 'dashboard/composables/useUISettings';

export function useKanbanAttribute() {
  const { uiSettings } = useUISettings();
  const contactAttributes = useMapGetter('attributes/getContactAttributes');

  const listAttributes = computed(() =>
    contactAttributes.value.filter(
      attribute => attribute.attributeDisplayType === 'list'
    )
  );

  const hasKanbanAttribute = computed(() => listAttributes.value.length > 0);

  const kanbanAttributeKey = computed(() => {
    const stored = uiSettings.value?.contacts_kanban_group_by_attribute_key;
    if (
      stored &&
      listAttributes.value.some(attribute => attribute.attributeKey === stored)
    ) {
      return stored;
    }
    return listAttributes.value[0]?.attributeKey || '';
  });

  const kanbanAttribute = computed(() =>
    listAttributes.value.find(
      attribute => attribute.attributeKey === kanbanAttributeKey.value
    )
  );

  return {
    listAttributes,
    hasKanbanAttribute,
    kanbanAttributeKey,
    kanbanAttribute,
  };
}
